@if (loadError(); as err) {
  <div class="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[12px] text-red-800">
    {{ err }}
  </div>
}

<header class="mb-5">
  <h2 class="text-[20px] font-bold text-midnight-indigo">Pipeline de acuerdos</h2>
  <p class="mt-1 text-[12px] text-steel-gray">
    Vista por etapas &middot; clic en una tarjeta para abrir la ficha completa.
  </p>
</header>

@if (loading()) {
  <p class="text-[13px] text-steel-gray">Cargando pipeline&hellip;</p>
} @else {
  <div class="overflow-x-auto pb-4">
    <div class="flex min-w-max gap-3">
      @for (col of board(); track col.id) {
        <section class="w-[260px] shrink-0">
          <!-- Column header (deals.png style) -->
          <div class="crm-pipeline-col-header mb-3 rounded-t-lg px-4 py-3" [class]="col.headerClass">
            <p class="text-[13px] font-bold">{{ col.label }} / {{ col.leads.length }}</p>
            @if (col.totalEstimate > 0) {
              <p class="mt-0.5 text-[12px] opacity-90">
                {{ formatEstimate(col.totalEstimate) }} potencial /h
              </p>
            }
          </div>

          <div class="space-y-2 rounded-b-xl border border-t-0 border-pale-gray bg-white/60 p-2 min-h-[320px]">
            @for (lead of col.leads; track lead.id) {
              <button
                type="button"
                (click)="openLead(lead.id)"
                class="w-full rounded-xl border border-pale-gray bg-white p-3 text-left shadow-sm transition hover:border-action-blue/30 hover:shadow-md">
                <p class="text-[13px] font-semibold text-midnight-indigo leading-snug">
                  {{ lead.venueName }}
                  @if ((lead.venueCount ?? 1) > 1) {
                    <span class="text-[10px] font-semibold text-action-blue">(+{{ (lead.venueCount ?? 1) - 1 }})</span>
                  }
                </p>
                <div class="mt-2 flex flex-wrap items-center gap-2">
                  <span class="rounded px-1.5 py-0.5 text-[10px] font-bold"
                        [class]="CRM_PRIORITY_COLORS[lead.priority]">
                    {{ CRM_PRIORITY_LABELS[lead.priority] }}
                  </span>
                  @if (lead.estimatedHourlyEur) {
                    <span class="text-[11px] text-steel-gray">
                      {{ formatEstimate(lead.estimatedHourlyEur) }}/h
                    </span>
                  }
                </div>
                <p class="mt-2 truncate text-[11px] text-steel-gray">
                  {{ lead.contactName || lead.city }}
                </p>
                <div class="mt-3 flex items-center justify-between text-steel-gray">
                  <span class="flex h-6 w-6 items-center justify-center rounded-full bg-cloud-mist text-[10px] font-bold text-midnight-indigo">
                    {{ lead.priority }}
                  </span>
                  <span class="inline-flex items-center gap-1 text-[10px]">
                    <lucide-icon name="message-circle" [size]="12" />
                    <lucide-icon name="calendar" [size]="12" />
                  </span>
                </div>
              </button>
            } @empty {
              <p class="px-2 py-6 text-center text-[11px] text-steel-gray">Sin leads</p>
            }
          </div>
        </section>
      }
    </div>
  </div>
}
